export const MIN_VERSIONS = {
  chrome: {
    default: 120,
  },
  'yandex browser': {
    default: 24.1,
  },
  'microsoft edge': {
    default: 121,
  },
  opera: {
    default: 98,
  },
  firefox: {
    default: 122,
    macos: 128,
    ios: 103,
    android: 125,
  },
  safari: {
    default: 17.4,
  },
} as const;
